import {SubmitEvent} from '@github-ui/filter-core'
import {SearchIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'

import {useFilterQueryDispatch} from '../context'
import styles from './SubmitButton.module.css'

export const SubmitButton = () => {
  const {onSubmit} = useFilterQueryDispatch()

  return (
    <IconButton
      aria-label="Search"
      size="medium"
      icon={SearchIcon}
      variant="default"
      onClick={() => {
        onSubmit(SubmitEvent.ExplicitSubmit, 'input_with_button')
      }}
      className={styles.IconButton_0}
    />
  )
}
